The way in which the response choices should be presented for selection.
